import { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  NumberInput,
  NumberInputField,
  Text,
  useToast,
  VStack,
} from '@chakra-ui/react';

const API_HEADERS = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

const BatchSettingsTab = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [maxBatchesPerUser, setMaxBatchesPerUser] = useState(3);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/batch-settings', { headers: API_HEADERS() });
      const body = await response.json();
      if (!response.ok) throw new Error(body.message || 'Não foi possível carregar');
      setMaxBatchesPerUser(body.data.maxBatchesPerUser);
    } catch (error) {
      toast({ title: error.message, status: 'error', duration: 4000 });
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => {
    load();
  }, [load]);

  const save = async () => {
    const value = Math.round(Number(maxBatchesPerUser));
    if (!Number.isFinite(value) || value < 1 || value > 50) {
      toast({
        title: 'Informe uma quantidade entre 1 e 50.',
        status: 'warning',
        duration: 4000,
      });
      return;
    }
    try {
      setSaving(true);
      const response = await fetch('/api/batch-settings', {
        method: 'PUT',
        headers: API_HEADERS(),
        body: JSON.stringify({ maxBatchesPerUser: value }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.message || 'Não foi possível salvar');
      setMaxBatchesPerUser(body.data.maxBatchesPerUser);
      toast({ title: 'Limite de lotes salvo', status: 'success', duration: 3000 });
    } catch (error) {
      toast({ title: error.message, status: 'error', duration: 4000 });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box bg="white" borderRadius="md" boxShadow="sm" p={6} maxW="720px">
      <Heading size="md" mb={2}>Lotes por usuário</Heading>
      <Text color="gray.600" mb={4}>
        Quantidade de lotes em análise que um usuário pode ter vinculado ao mesmo tempo.
        Vale para os níveis 2 e 3. A partir do nível 4 não há limite.
      </Text>

      <VStack align="stretch" spacing={5}>
        <FormControl>
          <FormLabel>Lotes vinculados por vez</FormLabel>
          <NumberInput
            min={1}
            max={50}
            value={maxBatchesPerUser}
            isDisabled={loading}
            onChange={(value) => setMaxBatchesPerUser(value)}
            maxW="160px"
          >
            <NumberInputField />
          </NumberInput>
          <FormHelperText>Entre 1 e 50. O padrão é 3.</FormHelperText>
        </FormControl>

        <Button
          colorScheme="teal"
          alignSelf="flex-start"
          isLoading={saving}
          isDisabled={loading}
          onClick={save}
        >
          Salvar
        </Button>
      </VStack>
    </Box>
  );
};

export default BatchSettingsTab;
